import React, {useEffect, useState} from "react";
import {Button, Card, Grid, Typography} from '@mui/material/';
import SearchBar from "../components/SearchBar";
import mentor_pic from './../mentor_pic.jpeg';
import axios from "axios";
import dummyMentors from "./../json/top3mentors.json";
import {Link, useNavigate} from 'react-router-dom';
import * as constants from './../constants'
import {List, ListItem} from "@mui/material";
import MenuAppBar from "../components/MenuAppBar";

/**
 * Displays a list of all mentors
 * @returns {Element}
 * @constructor
 */
export default function Admin() {
    const [error, setError] = useState('')
    const [sqlData, setSqlData] = useState([])

    //Run when first loading
    useEffect(() => {
        //get list of all mentors from the server
        axios.get(constants.serverURL + "adminData",      {
            withCredentials: true,
        }).then(response => {
            let sqlData = []
            for (let i = 1; i < response.data.length; i++) {
                if (response.data[i].length > 0) {
                    const items = response.data[i]
                    const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
                    const header = Object.keys(items[0])
                    const csv = [
                        header.join(','), // header row first
                        ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
                    ].join('\r\n')
                    sqlData.push(csv)
                } else {
                    sqlData.push("")
                }
            }
            setSqlData(sqlData)

        }).catch((error) => {
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=topMentors'
            } else {
                setError(error.request.responseText)
            }
        })
    }, [])

    let DownloadButton = (data) => {
        if (sqlData.length > 0) {
            const file = new Blob([sqlData[data.option]], {type: 'text/plain'});
            console.log(file)
            let fileName = "1.csv"
            switch (data.option) {
                case 1:
                    fileName = "userData.csv"
                    break
                case 2:
                    fileName = "menteeData.csv"
                    break
                case 3:
                    fileName = "mentorData.csv"
                    break
                case 4:
                    fileName = "sessionData.csv"
                    break
                case 5:
                    fileName = "externalSessionData.csv"
                    break
            }
            return (
                <Button variant="outlined">
                    <a download={fileName} target="_blank" rel="noreferrer" href={URL.createObjectURL(file)} style={{
                        textDecoration: "inherit",
                        color: "inherit",
                    }}>{data.text}</a>
                </Button>
            )
        }
    }

    //Render page
    return (
        <div>
            <MenuAppBar title="Mentee Survey" signedIn={true}></MenuAppBar>
            <div className="screen">
                <a>Admin Page</a>
                <DownloadButton option={1} text="Download user data"/><br/>
                <DownloadButton option={2} text="Download mentee data"/><br/>
                <DownloadButton option={3} text="Download mentor data"/><br/>
                <DownloadButton option={4} text="Download mentor session data"/><br/>
                <DownloadButton option={5} text="Download external session data"/><br/>
            </div>
        </div>
    )
}
